<template>

	<section class="section">

		<svg height="0" width="0" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.04 148.97">
			<defs></defs>
			<clipPath id="rose" clipPathUnits="objectBoundingBox" transform="scale(0.01148897,0.00671276)">
			<path class="cls-1" d="M34,.5C24.44.5,21.16,5.78,14.59,11.7.79,28.78.5,58.35.5,74.5S11.3,93.83,15.57,105s-2,22.67,1.32,32.52,7.23,12.81,14.78,9.86S47.11,117.5,54,106.64s29.24-20,31.87-40.08-3-42.46-10.51-52.23S43.5.5,34,.5Z"/>
			</clipPath>
		</svg>

		<svg  height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 557.28 541"><defs></defs>
			<clipPath id="transp" clipPathUnits="objectBoundingBox" transform="scale(0.00179443008,0.00184842883)">
			<path d="M556.4,277.56c8.43,196.17-125.2,262.91-278.22,262.91C178.56,542.64-20.31,437.33,2.27,277.56S107.09.5,279.33.5,548,81.39,556.4,277.56Z" transform="translate(0)"/>
			</clipPath>
		</svg>

		<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.53 129">
			<defs>
			</defs>
			<clipPath id="bleu" clipPathUnits="objectBoundingBox" transform="scale(0.00622936522,0.00775193798)">
			<path class="cls-1" d="M102.36,16.79c-15,0-8,15-27,20.5s-65-13.5-73,23.5,22,37.48,35,48c12,9.72,17,36,65,36s46-12,56-31-17-69-24-83S117.36,16.79,102.36,16.79Z" transform="translate(-0.53 -16.29)"/>
			</clipPath>
		</svg>

		<div class="container">    


			<div class="row justify-content-between align-items-center">
				<div class="col-sm-6 content">
					<p class="citation">
Celui qui est maître de lui même est plus puissant que le maître du monde.
					</p>

					<div class="row justify-content-around" style="height: 50px;"></div>

						<div class="gauche">
							<transition name="FadeSlide1" appear ><img style="" src="../assets/img/nasa-08-marron.svg"></transition>
						</div>

						<div class="relax" style="">
							<h3>Sophro-Relax</h3>

							<p><span style="font-weight:bold;">Sophro-Relax</span> est une séance de sophrologie sans visée thérapeutique.<br><br>
Vous pourrez évacuer vos tensions physiques, émotionnelles  et mentales dans l’intention de vous détendre, de vous relaxer.<br><br>
Je vous propose également des séances de relaxation <span style="font-weight:bold;">au son des bols tibétains</span> qui procurent un relâchement équivalent à <span style="font-weight:bold;">une profonde relaxation</span>.<br><br>
Offrez-vous ou offrez, une pause détente en prenant rendez-vous pour une <span style="font-weight:bold;">expérience hors du commun</span>.<br><br> Séance Sophro-Relax 1h00 - 40 €.
							</p>

						</div>

					</div>

					<div class="col-sm-6">
						<div style="position:inherit;z-index:2;">
							<img class="img-fluid" style="-webkit-clip-path:url(#transp);clip-path:url(#transp);max-width:80%;" src="../assets/img/bols.jpg">
						</div>
					<div>
						<transition name="FadeSlide2" appear ><img class="centre" style="" src="../assets/img/nasa-01-blanc.svg"></transition>
					</div>
					<div>
						<transition name="FadeSlide3" appear ><img class="droite" style="" src="../assets/img/nasa-08-rose.svg"></transition>
					</div>
				</div>
				<div class="col-sm-12">
				</div>
			</div>


		</div>    


	</section>
</template>


<script>

export default {
  name: 'Relax',
  metaInfo: function(){
	return{
    title: "Emmanuelle Vignon",
    titleTemplate: '%s | Sophro-Relax',
        meta: [
      { hid: "description", name: "description", content: " Sophro-Relax est une séance de sophrologie sans visée thérapeutique " },
      { hid: "keywords", name: "keywords", content: " sophrologie, relaxation, blois, huisseau sur cosson, loir et cher, 41, bols tibétains, méditation, bienêtre, sophrologue, détente, détente musculaire, corps, mental, détente mentale, blocages, fatigue, harmonie, sérénité, sonothérapie, lacher prise " }      //you can also add open graph tags here
    ]
  }},
  components: {
    
    }
  }
</script>


<style scoped>
.relax{
	z-index: 4;
	position: relative;
}
.relax p{
	font-size: 16px;
	padding-top:10px;
	text-align: justify;
}
.relax h3{
	font-weight: 500;
}
.centre{
	height: 75%;
background: none;
position: absolute;
width: 75%;
z-index: 1;
bottom: -10%;
left: 5%;
}
.gauche{
	height: 60%;
position: absolute;
width: 50%;
z-index: 1;
bottom: -10%;
left: -35%;
clip-path:url(#rose);
-webkit-clip-path:url(#rose);
}
.droite{
	height: 75%;
position: absolute;
z-index: 1;
bottom: -5%;
right: 5%;
}

/*$$$$$$$$$ ANIMATIONS IMAGES $$$$$$$$*/

.FadeSlide1-enter-active, .FadeSlide1-leave-active {
  transition: all 10s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide1-enter, .FadeSlide1-leave-to  {
  opacity: 0;
  transform: translate(-50px,0);
}
.FadeSlide2-enter-active, .FadeSlide2-leave-active {
  transition: all 6s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide2-enter, .FadeSlide2-leave-to {
  opacity: 0;
  transform: translate(25px,-25px);
}
.FadeSlide3-enter-active, .FadeSlide3-leave-active {
  transition: all 6s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide3-enter, .FadeSlide3-leave-to {
  opacity: 0;
  transform: translate(-25px,-25px);
}

</style>
